import { supabase } from "../supabaseClient";

async function updateLeadPersonTable(personId, obj) {
	const { data, error } = await supabase.from("Person").update(obj).eq("personId", personId);
	if (data) return data;
	else throw error;
}
async function getUserDetails(userId) {
	const { data, error } = await supabase.from("Users").select("*").eq("userId", userId).single();
	if (data) return data;
	else throw error;
}
async function updateLeadLoginTable(customerId, obj) {
	const { data, error } = await supabase.from("LeadLogin").update(obj).eq("CUID", customerId);
	if (data) return data;
	else throw error;
}
export { updateLeadPersonTable, getUserDetails, updateLeadLoginTable };
